export default "__VITE_ASSET__DV$UeLn2__"